<template>
  <b-modal class="modal-lg" id="newLinkModal" title='New Parent Link' :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="hideModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><i class="os-icon os-icon-file text-light"></i> New Parent Link</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-1" label="Link URL" label-for="input-1">
            <b-form-input id="input-1" v-model="newLink.url" type="text" required placeholder="Link Url"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label="Link Translation Key" label-for="input-2">
            <b-form-input id="input-2" v-model="newLink.translationKey" type="text" required placeholder="Translation Key"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-3" label="Column" label-for="input-3">
            <b-form-input id="input-3" v-model="newLink.group" type="text" required placeholder="Column"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-4" label="Link Position" label-for="input-4">
            <b-form-input id="input-4" v-model="newLink.position" type="text" required placeholder="Position"></b-form-input>
          </b-form-group>
          <!--<b-form-group id="input-group-5" label="Parent Link" label-for="input-5">
            <select id="input-5" class="form-control" v-if="parentNavs" v-model="newLink.parent">
              <option value="">Select parent link</option>
              <option v-for="link in parentNavs" :value="link.id" :key="link.id">{{ t(link.item_key, link.item_key) }}</option>
            </select>
          </b-form-group>-->
        </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>Cancel
      </button>
      <button aria-label="Create Link" data-dismiss="modal" class="btn btn-primary" type="button" :disabled="isBusy" @click="createParentLink()">
        <fontAwesomeIcon :icon="['fa', 'thumbs-up']" class="text-light mr-2"/>Create Link
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'NewLinkNavigationModal',
  props: ['userLevels', 'parentId'],
  data() {
    return {
      newLink: {
        url: '',
        translationKey: '',
        position: 0, // position in column
        group: 0, // column
        parent: 0,
        type: ''
      },
      parentNavs: [],
      isBusy: false
    }
  },
  methods: {
    hideModal() {
      this.$parent.disableOverlay()
    },
    createParentLink() {
      let self = this
      this.newLink.userLevel = this.$parent.$parent.currentUserLevel
      this.newLink.parent = this.$props.parentId
      this.newLink.type = 'new_link_created'
      this.$store.dispatch('menuBuilderStore/createNewLink', this.newLink).then(() => {
        self.$parent.disableOverlay()
        self.$parent.$parent.getNavigation()
        self.$root.$emit('bv::hide::modal', 'newLinkModal')
      })
    },
    openIconsList() {
      window.open('http://light.pinsupreme.com/icon_fonts_light_admin.html','_blank')
    },
    clearData() {
      this.newLink.url = ''
      this.newLink.translationKey = ''
      this.newLink.position = 0
      this.newLink.group = 0
      this.newLink.parent = 0
    }
  }
}
</script>

<style scoped>
.clickable-link {
  cursor: pointer;
  color: #047bf8;
}

.clickable-link:hover {
  font-weight: 600;
  text-decoration: underline;
}
</style>